// Three allocates immutable WebGL2 texture storage on first upload. When a
// responsive canvas changes size, release that storage before uploading again.
export function resizeTextureCanvas(canvas, texture, width, height) {
  if (canvas.width === width && canvas.height === height) return false;
  texture.dispose();
  canvas.width = width; canvas.height = height;
  texture.needsUpdate = true;
  return true;
}
